<template>
	<div class="token-display">{{ token }}</div>
</template>

<script>
export default {
	name: "TokenViewer",
	props: {
		token: {
			type: String,
			default: null
		}
	}
}
</script>

<style scoped lang="scss">
.token-display {
	margin: 0;
	padding: 24px 16px;
	font-family: "Courier New", monospace;
	font-size: 36px;
	font-weight: 700;
	letter-spacing: 6px;
	text-align: center;
	background: rgba(var(--rgb-bg-primary-1), 0.5);
	border-radius: 12px;
	user-select: all;
	word-break: break-all;
	width: 100%;
}
</style>
